<div class="modal-header card-header">
    <div class="col-md-8 col-xs-8">
        <span class="text-blue text-125">Registro Jugador</span>
    </div>
    <div class="col-md-6 col-xs-6">
        <button (click)="guardarJugador()" class="btn btn-primary"  >
            <i class="fa fa-save text-110 mr-1"></i>
        </button>&nbsp;
        <button class="btn btn-danger" type="button" (click)="cerrarComponente()">
            <i class="fa fa-times red2 text-110 mr-1"></i>
        </button>
    </div>
</div>
<div class="modal-body card-body">

    <!--<div class="modal fade" id="cameraModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-nb modal-dialog-centered" role="document"> 
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabel">Camara</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <webcam [width]="300" [height]="500" [trigger]="triggerObservable" (imageCapture)="handleImage($event)"></webcam>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">
                        <i class="fa fa-times red2 text-110 mr-1"></i>
                    </button>
                    <button (click)="capturarImagen()" class="btn btn-warning" data-dismiss="modal">
                        <i class="fa fa-camera bigger-110 red2"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>-->

    <div class="modal fade" id="cameraModalCi" tabindex="-1" role="dialog" aria-labelledby="myModalLabelCi" aria-hidden="true">
        <div class="modal-dialog modal-nb modal-dialog-centered" role="document"> 
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelCi">Camara</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <webcam [width]="300" [height]="500" [trigger]="triggerObservable" (imageCapture)="handleImageCi($event)"></webcam>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">
                        <i class="fa fa-times red2 text-110 mr-1"></i>
                    </button>
                    <button (click)="capturarImagenCi()" class="btn btn-warning" data-dismiss="modal">
                        <i class="fa fa-camera bigger-110 red2"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="cropModal" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog modal-nb modal-dialog-centered" role="document"> 
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabel">Recortar</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body card-body">
                    
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">
                        <i class="fa fa-times red2 text-110 mr-1"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <label>Capturar/Subir Foto C.I.</label>
        </div>
        <div class="col-7">
          <img *ngIf="jugador.persona.imagen && jugador.persona.imagen.length<100" [src]="rest_server+jugador.persona.imagen" width="150" />
          <img *ngIf="jugador.persona.imagen && jugador.persona.imagen.length>100" [src]="jugador.persona.imagen" width="150" />
        </div>
        <div class="col-5">
            <!--<button class="btn btn-success" data-toggle="modal" data-target="#cropModal" >
                <i class="fas fa-crop bigger-110 red2"></i>
            </button>&nbsp;-->
            <div class="col-12">
                <label>Subir Foto Jugador</label>
                <!--<button class="btn btn-warning" data-toggle="modal" data-target="#cameraModal" >
                    <i class="fa fa-camera bigger-110 red2"></i>
                </button>&nbsp;-->
                <button (click)="clickBotonSubir('subir-foto-jugador')" class="fileUpload btn btn-primary" aria-label="Export" type="button" title="Subir foto ci" aria-expanded="false">
                    <i class="fa fa-upload text-red fileUpload-button"></i>
                    <input *ngIf="webcamImage" id="subir-foto-jugador" style="display:none" type="file" class="form-control" (change)="fileChangeEvent($event)" placeholder="Upload file" accept=".png,.jpg,.jpeg">
                    <input *ngIf="!webcamImage" id="subir-foto-jugador" style="display:none" type="file" class="form-control" (change)="subirArchivoFoto($event)" placeholder="Upload file" accept=".png,.jpg,.jpeg">
                </button>
            </div>
            <div class="col-12">
                <label>Capturar/Subir Foto Cedula Identidad I.A.</label>
                <button class="btn btn-warning" data-toggle="modal" data-target="#cameraModalCi" >
                    <i class="fas fa-address-card bigger-110 red2"></i>
                </button>&nbsp;
                <button (click)="clickBotonSubir('subir-foto-ci')" class="fileUpload btn btn-primary" aria-label="Export" type="button" title="Subir foto ci" aria-expanded="false">
                    <i class="fa fa-upload text-red fileUpload-button"></i>
                    <input id="subir-foto-ci" style="display:none" type="file" class="form-control" (change)="subirArchivoCi($event)" placeholder="Upload file" accept=".png,.jpg,.jpeg">
                </button>
            </div>
            <!--<button (click)="clickBotonSubir('subir-foto-ci')" class="fileUpload btn btn-primary" aria-label="Export" type="button" title="Subir foto ci" aria-expanded="false">
                <i class="fa fa-id-card text-red fileUpload-button"></i>
                <input *ngIf="webcamImage" id="subir-foto-ci" style="display:none" type="file" class="form-control" (change)="fileChangeEvent($event)" placeholder="Upload file" accept=".png,.jpg,.jpeg">
                <input *ngIf="!webcamImage" id="subir-foto-ci" style="display:none" type="file" class="form-control" (change)="subirArchivoFoto($event)" placeholder="Upload file" accept=".png,.jpg,.jpeg">
            </button>-->
        </div>
    </div>
    <div class="row">
        <div class=" col-5 col-sm-12 col-md-6">
            <label>Código</label>
            <input [disabled]="codigo_automatico" required type="text" id="codigo" name="codigo" [(ngModel)]="jugador.codigo" placeholder="Código" class="form-control" />
        </div>
        <div class="col-7 col-sm-12 col-md-6">
            <div class="col-sm-12 col-md-3">
                <label>C.I.</label>
            </div>
            <div class="col-sm-12 col-md-9">
                <input name="ci" (change)="buscarCiJugador()" required type="text" [(ngModel)]="jugador.persona.ci" placeholder="C.I." class="form-control" />
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-3">
            <label>Apellido Paterno</label>
        </div>
        <div class="col-sm-12 col-md-9">
            <input name="nombre" required type="text" (keyup)="jugador.persona.apellido_paterno = $event.target.value.toUpperCase()" [(ngModel)]="jugador.persona.apellido_paterno" placeholder="Apellido Paterno" class="form-control" />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-3">
            <label>Apellido Materno</label>
        </div>
        <div class="col-sm-12 col-md-9">
            <input name="nombre" required type="text" (keyup)="jugador.persona.apellido_materno = $event.target.value.toUpperCase()" [(ngModel)]="jugador.persona.apellido_materno" placeholder="Apellido Materno" class="form-control" />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-3">
            <label>Nombre</label>
        </div>
        <div class="col-sm-12 col-md-9">
            <input name="nombre" required type="text" (keyup)="jugador.persona.nombres = $event.target.value.toUpperCase()" [(ngModel)]="jugador.persona.nombres" placeholder="Nombres" class="form-control" />
        </div>
    </div>
    <hr>
    <div class="row">
        <div class="col-sm-12 col-md-3">
            <label>Fecha de Nacimiento</label>
        </div>
        <div class="col-sm-12 col-md-9">
          <div class="input-group">
            <input name="fecha_nacimiento_texto" class="form-control" placeholder="dd/mm/yyyy"
                    name="dp" [(ngModel)]="jugador.persona.fecha_nacimiento_texto" ngbDatepicker #d="ngbDatepicker">
            <div class="input-group-append">
                <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
            </div>
        </div> 
        </div>
    </div>
    <hr>
    <div class="row">
        <div class="col-sm-12 col-md-3">
            <label>Posición</label>
        </div>
        <div class="col-sm-12 col-md-9">
            <input name="posicion" required type="text" [(ngModel)]="jugador.posicion" placeholder="Posición" class="form-control" />
        </div>
    </div>

    <div class="row" *ngIf="usando_camara">
        <image-cropper
            [imageBase64]="webcamImage.imageAsDataUrl"
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            [aspectRatio]="1/1"
            format="png"
            output="base64"
            resizeToWidth="150"
            resizeToHeight="150"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded($event)"
            (cropperReady)="cropperReady()"
            (loadImageFailed)="loadImageFailed()"
        ></image-cropper>
    </div>
    <div class="row" *ngIf="!usando_camara">
        <image-cropper
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            [aspectRatio]="1/1"
            format="png"
            output="base64"
            resizeToWidth="150"
            resizeToHeight="150"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded($event)"
            (cropperReady)="cropperReady()"
            (loadImageFailed)="loadImageFailed()"
        ></image-cropper>
    </div>
</div>